export default function Exercises() {}
